import React from 'react';

interface ExportProps {
    fill?: string;
}

export const Export = ({ fill = '#818998' }: ExportProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_435_1542)">
            <path
                d="M10.3579 2.25H5.0625C4.13213 2.25 3.375 3.00712 3.375 3.9375V9H4.5V3.9375C4.5 3.62756 4.752 3.375 5.0625 3.375H9.5625V7.3125H13.5V14.625H4.5V12.375H3.375V15.75H14.625V6.51713L10.3579 2.25ZM10.6875 4.17037L12.7046 6.1875H10.6875V4.17037ZM7.87331 11.25H2.25V10.125H7.8795L6.58462 8.83631L7.38 8.04094L9.23569 9.89606C9.44481 10.1062 9.56221 10.3905 9.56221 10.6869C9.56221 10.9834 9.44481 11.2677 9.23569 11.4778L7.37944 13.3335L6.58406 12.5381L7.87331 11.25Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_435_1542">
                <rect width="13.5" height="13.5" fill="white" transform="translate(2.25 2.25)" />
            </clipPath>
        </defs>
    </svg>
);
